module.exports = __webpack_public_path__ + "img/09.77d49f3a.png";